import React from 'react';
import { Box } from '@mui/material';
import About from './section-components/about';
import TestimonialV3 from './section-components/Testimonial-v3';
import bgImage from '../assets/img/newimgaes/About us.jpeg';
import { Pageheader } from './global-components/page-header';

const AboutPage = () => {
  return (
    <Box sx={{ backgroundColor: '#e0f7fa' }}>
      <Pageheader headertitle="About Us" bgImage={bgImage} isAbout/>
      <About />
      {/* <TestimonialV3 /> */}
    </Box>
  );
};

export default AboutPage;
